import { Injectable } from '@angular/core';
import { Angular2Csv } from 'angular2-csv';
import { AuthenticationService } from '../../shared/services/authentication.service';


@Injectable()
export class ExportService {

  constructor(public _authService: AuthenticationService) { }

  asCsvWithHeaders (data: any[]) {
/*
    EXAMPLE:

    this.branches.forEach(
      function(b) {
        toExport.push({
          "ID": b.id,
          "Name": b.name,
          "Code": b.code,
          "Address": b.address,
          "City": b.city_name,
          "Country": b.country_name,
          "Sales Tax": b.sales_tax,
          "Company Name": b.company_name,
          "Currency": b.currency_name,
          "Currency Code": b.currency_code,
          "Currency Symbol": b.currency_symbol,
          "Contact Name": b.contact_name,
          "Contact email": b.contact_email,
          "Contact Phone": b.contact_phone,
          "Contact Mobile": b.contact_mobile,
          "Contact Fax": b.contact_fax,         
          "Contact Address": b.contact_address,
          "Contact City": b.contact_city_name,
          "Contact Country": b.contact_country_name
        });
      }
    );    
*/    

  }

  asCsv(data: any[], name: string) {
    if (data == null) return;

    let separator = this._authService.getUsableCsvSeparator();
    
    var options = {
      fieldSeparator: separator,
      showLabels: true
    };

    console.log('separator: ' + options.fieldSeparator);

    //Prepare headers as per the object
    let headers: string[] = [];
    if (data.length > 0) {
      for (let prop in data[0]){
        headers.push(prop);
      }
    }

    //Then get it all together    
    let toExport : any[] = data.slice();
    toExport.unshift(headers);
    
    // And download
    new Angular2Csv(toExport, name, options);    
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/export.service.ts